  import { Injectable } from '@angular/core';
import * as S3 from 'aws-sdk/clients/s3';
import { GLOBAL } from '../global';
import { Adjunto } from '../domain/adjunto';
import { Subscription, Observable, of } from 'rxjs';
import { AdjuntoService } from './adjunto.service';
import { GenericResponse } from '../domain/genericResponse';
import { concatMap } from 'rxjs/operators';
import { Banner } from '../domain/banner';
import { BannerService } from './banner.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ParametroService } from './parametro.service';

@Injectable({
  providedIn: 'root'
})
export class AmazonS3Service {

  public listAdjunto: Array<Adjunto>;
  url: string;
  subscription: Subscription;
  adjuntoS3: Adjunto;

  constructor(public adjuntoService: AdjuntoService,
    public bannerService: BannerService,
    private spinnerService: Ng4LoadingSpinnerService) {

  }

  /**
   * 
   * @author Freddy Sebastian Garcia Victoria
   * @version 2018-10-12
   *  
  */
  uploadFile(usuaCreador: string, file: File, rutaInicial: string, secretId: string, secretKey: string ) {

    var adjunto = new Adjunto(null, file.name, null,
      null, null, rutaInicial, file.type, usuaCreador, null, null, null, null);
    try {


      //console.log("TC= " + file.type)
      //console.log("TA= " + adjunto.usuarioCreador)

      this.subscription = this.adjuntoService.saveAdjuntoToS3(adjunto).subscribe(data => {
        let respuestaGenerica: GenericResponse = data;
        if (respuestaGenerica.codigo === GLOBAL.HTTP_OK) {
          this.adjuntoS3 = respuestaGenerica.lista[0];

          //console.log("Ruta= " + this.adjuntoS3.rutaAdjunto);

          const bucket = new S3(
            {
              accessKeyId: secretId,
              secretAccessKey: secretKey,
              region: GLOBAL.REGION_S3
            }
          );

          const params = {
            Bucket: GLOBAL.NOMBRE_BUCKET,
            Key: this.adjuntoS3.rutaAdjunto,
            ACL: "public-read",
            Body: file
          };

          bucket.upload(params, function (err, data) {
            if (err) {
              //console.log('Hay un error al subir el adjunto: ', err);
            }

            //console.log('El adjunto fue cargado con éxito.', data);
          });

        } else {
          throw new Error('¡Ha ocurrido un error al guardar el adjunto! ' + respuestaGenerica.mensaje);
        }

      }, error => {
        throw new Error('¡Ha ocurrido un error al cargar el adjunto, por favor, intente más tarde!');
      });

    } catch (error) {
      //console.log(error);
    }
  }

  /**
 * 
 * @author Freddy Sebastian Garcia Victoria
 * @version 2018-10-12
 *  
*/
  modifyUploadedFile(usuaModificador: string, file: File, rutaInicial: string, adjuIdAnterior: number, secretId: string, secretKey: string ) {
    try {

      var adjunto = new Adjunto(null, file.name, null,
        null, null, rutaInicial, file.type, usuaModificador, usuaModificador, adjuIdAnterior, null, null);

      //console.log("TC= " + adjunto.adjuIdAnterior)
      //console.log("TA= " + adjunto.usuarioModificador)

      this.subscription = this.adjuntoService.modifyUploadedSicaAdjuntoAmazonS3(adjunto).subscribe(data => {
        let respuestaGenerica: GenericResponse = data;
        if (respuestaGenerica.codigo === GLOBAL.HTTP_OK) {
          this.listAdjunto = respuestaGenerica.lista;
          this.adjuntoS3 = this.listAdjunto[0];

          //console.log("Ruta= " + this.adjuntoS3.rutaAdjunto);

          const bucket = new S3(
            {
              accessKeyId: secretId,
              secretAccessKey: secretKey,
              region: GLOBAL.REGION_S3
            }
          );

          const params = {
            Bucket: GLOBAL.NOMBRE_BUCKET,
            Key: this.adjuntoS3.rutaAdjunto,
            ACL: "public-read",
            Body: file
          };

          bucket.upload(params, function (err, data) {
            if (err) {
              //console.log('Hay un error al subir el adjunto: ', err);
            }

            //console.log('El adjunto fue cargado con éxito.', data);
          });

          //console.log("Ruta= " + this.adjuntoS3.rutaAdjuntoAnterior);

          const paramsBucketAnt = {
            Bucket: GLOBAL.NOMBRE_BUCKET,
            Key: this.adjuntoS3.rutaAdjuntoAnterior
          };

          bucket.deleteObject(paramsBucketAnt, function (err, data) {
            if (err) {
              //console.log('Hay un error al eliminar el adjunto: ', err);
            }

            //console.log('El adjunto fue eliminado con éxito.', data);
          });

        } else {
          throw new Error('¡Ha ocurrido un error al modificar el adjunto! ' + respuestaGenerica.mensaje);
        }
        return this.adjuntoS3;
      }, error => {
        throw new Error('¡Ha ocurrido un error al cargar el adjunto, por favor, intente más tarde!');
      });


    } catch (error) {
      //console.log(error);
    }
  }

  /**
* 
* @author Freddy Sebastian Garcia Victoria
* @version 2018-10-12
*  
*/
  inactiveBucketFile(adjuId: number, usuaModificador: string, secretId: string, secretKey: string ) {
    try {

      var adjunto = new Adjunto(adjuId, null, null,
        null, null, null, null, null, usuaModificador, null, null, null);

      //console.log("TC= " + adjunto.adjuId)
      //console.log("TA= " + adjunto.usuarioModificador)

      this.subscription = this.adjuntoService.inactiveSicaAdjuntoAmazonS3(adjunto).subscribe(data => {
        let respuestaGenerica: GenericResponse = data;
        if (respuestaGenerica.codigo === GLOBAL.HTTP_OK) {
          this.listAdjunto = respuestaGenerica.lista;
          this.adjuntoS3 = this.listAdjunto[0];

          //console.log("Ruta= " + this.adjuntoS3.rutaAdjunto);

          const bucket = new S3(
            {
              accessKeyId: secretId,
              secretAccessKey: secretKey,
              region: GLOBAL.REGION_S3
            }
          );

          const params = {
            Bucket: GLOBAL.NOMBRE_BUCKET,
            Key: this.adjuntoS3.rutaAdjunto
          };

          bucket.deleteObject(params, function (err, data) {
            if (err) {
              //console.log('Hay un error al eliminar el adjunto: ', err);
            }

            //console.log('El adjunto fue eliminado con éxito.', data);
          });

        } else {
          throw new Error('¡Ha ocurrido un error al modificar el adjunto! ' + respuestaGenerica.mensaje);
        }
        return this.adjuntoS3;
      }, error => {
        throw new Error('¡Ha ocurrido un error al cargar el adjunto, por favor, intente más tarde!');
      });


    } catch (error) {
      //console.log(error);
    }
  }

  public showNg4Spinner(): void {
    this.spinnerService.show();
  }

  public hideNg4Spinner(): void {
    this.spinnerService.hide();
  }

  /**
	 * Metodo encargado de crear un banner, subiendo ademas la imagen respectiva al bucket s3.
   * 
   * Se utiliza concatMap de rxjs para concatenar cada uno de los observables, que representan 
   * cada servicio, secuencialmente sin que se ejecuten en desorden.
   * 
   * Se utilizan promesas para ejecutar las funciones async de sdk de aws s3.
	 *
	 * @author Andrés Felipe Vargas López
	 * @version Dec 15, 2018
	 * @since 6.2.4
   * @param usuaCreador - Usuario que utiliza el metodo
   * @param file - Imagen cargada
   * @param rutaInicial - Ruta inicial en el bucket S3 de amazon
   * @param banner - POJO a ser enviado al servicio.
	 * @throws Error
	 * @returns Observable<any>
	 */
  public createBanner(usuaCreador: string, file: File, rutaInicial: string, banner: Banner, secretId: string, secretKey: string ): Observable<any> {

    var adjunto = new Adjunto(null, file.name, null,
      null, null, rutaInicial, file.type, usuaCreador, null, null, null, null);

    const thread = this.adjuntoService.saveAdjuntoToS3(adjunto).pipe(
      concatMap((respuestaGenerica: GenericResponse) => {
        if (respuestaGenerica.codigo === GLOBAL.HTTP_OK) {

          const bucket = new S3(
            {
              accessKeyId: secretId,
              secretAccessKey: secretKey,
              region: GLOBAL.REGION_S3
            }
          );

          const params = {
            Bucket: GLOBAL.NOMBRE_BUCKET,
            Key: respuestaGenerica.lista[0].rutaAdjunto,
            ACL: "public-read",
            Body: file
          };

          let response = [respuestaGenerica.lista[0], bucket.upload(params, function (err, data) {
            if (err) {
              throw ("No fué posible subir el archivo: " + err);
            }
          }).promise()];

          return of(response);

        } else {
          throw (respuestaGenerica.mensaje);
        }
      }),
      concatMap((response: any) => {
        if (response == null || response == undefined) {
          throw ("No fué posible cargar el archivo");
        }
        if (response[0] == null || response[0] == undefined) {
          throw ("No fué posible cargar el archivo");
        }
        banner.adjuId_SicaAdjunto = response[0].adjuId;
        return of(response[1], this.bannerService.grabar(banner).toPromise());
      }),
      concatMap((response: Promise<any>) => {
        return new Promise((resolve, reject) => {
          response.then(
            function (result) {
              if (result !== null && result !== undefined && result.codigo !== undefined && result.codigo !== null) {
                let response: GenericResponse = result;
                if (response.codigo !== GLOBAL.HTTP_OK) {
                  throw (result.mensaje);
                }
              }
              resolve(result);
            }, function (err) {
              reject(err);
            });

        }).then(function (result) {
          return result;
        }, function (err) {
          throw (err);
        });

      })
    );

    return thread;

  }

  /**
	 * Metodo encargado de actualizar un banner, subiendo ademas la imagen respectiva al bucket s3 e
   * inactivando la imagen anterior, dado que haya sido cambiada.
   * 
   * Se utiliza concatMap de rxjs para concatenar cada uno de los observables, que representan 
   * cada servicio, secuencialmente sin que se ejecuten en desorden.
   * 
   * Se utilizan promesas para ejecutar las funciones async de sdk de aws s3.
   * 
   * FIXME: A la fecha (2018/12/17) hasta la version 2.377.0(2.4.8) el sdk de aws para javascript tiene un bug para
   * cuando se requiere borrar objetos en el bucket. El codigo del bug es: SignatureDoesNotMatch
	 *
	 * @author Andrés Felipe Vargas López
	 * @version Dec 15, 2018
	 * @since 6.2.4
   * @param usuModificador - Usuario que utiliza el metodo
   * @param file - Imagen cargada
   * @param rutaInicial - Ruta inicial en el bucket S3 de amazon
   * @param banner - POJO a ser enviado al servicio.
   * @param adjuIdAnterior - Imagen anterior a ser inactivada.
	 * @throws Error
	 * @returns Observable<any>
	 */
  public updateBanner(usuModificador: string, file: File, rutaInicial: string, banner: Banner, secretId: string, secretKey: string ): Observable<any> {

    var adjunto = new Adjunto(null, file.name, null,
      null, null, rutaInicial, file.type, usuModificador, usuModificador, banner.adjuId_SicaAdjunto, null, null);

    const thread = this.adjuntoService.modifyUploadedSicaAdjuntoAmazonS3(adjunto).pipe(
      concatMap((respuestaGenerica: GenericResponse) => {
        if (respuestaGenerica.codigo === GLOBAL.HTTP_OK) {

          const bucket = new S3(
            {
              accessKeyId: secretId,
              secretAccessKey: secretKey,
              region: GLOBAL.REGION_S3
            }
          );

          const params = {
            Bucket: GLOBAL.NOMBRE_BUCKET,
            Key: respuestaGenerica.lista[0].rutaAdjunto,
            ACL: "public-read",
            Body: file
          };

          const paramsBucketAnt = {
            Bucket: GLOBAL.NOMBRE_BUCKET,
            Delete: {
              Objects: [
                { Key: respuestaGenerica.lista[0].rutaAdjunto }
              ]
            }
          };

          let response = [respuestaGenerica.lista[0], bucket.upload(params, function (err, data) {
            if (err) {
              throw ("No fué posible subir el archivo: " + err);
            }
          }).promise(), bucket.deleteObjects(paramsBucketAnt, function (err, data) {
            if(err !== null && err !== undefined && 
              !((err.stack as string).toLowerCase().includes(GLOBAL.BUG_ERROR_S3.toLowerCase()))){
              throw ("No fué posible actualizar el archivo: " + err);
            }
          }).promise()];

          return of(response);

        } else {
          throw (respuestaGenerica.mensaje);
        }
      }),
      concatMap((response: any) => {
        if (response == null || response == undefined) {
          throw ("No fué posible cargar el archivo");
        }
        if (response[0] == null || response[0] == undefined) {
          throw ("No fué posible cargar el archivo");
        }
        banner.adjuId_SicaAdjunto = response[0].adjuId;
        return of(response[2], response[1], this.bannerService.actualizar(banner).toPromise());
      }),
      concatMap((response: Promise<any>) => {
        return new Promise((resolve, reject) => {
          response.then(
            function (result) {
              if (result !== null && result !== undefined && result.codigo !== undefined && result.codigo !== null) {
                let response: GenericResponse = result;
                if (response.codigo !== GLOBAL.HTTP_OK) {
                  throw (result.mensaje);
                }
              }
              resolve(result);
            }, function (err) {
              if(err !== null && err !== undefined && 
                !((err.stack as string).toLowerCase().includes(GLOBAL.BUG_ERROR_S3.toLowerCase()))){
                  reject(err);
              }else{
                resolve(err);
              }
            });

        }).then(function (result) {
          return result;
        }, function (err) {
          throw (err);
        });

      })

    );

    return thread;

  }

  /**
	 * Metodo encargado de inactivar un banner, tanto en el bucket s3 de amazon como en la
   * base de datos.
   * 
   * Se utiliza concatMap de rxjs para concatenar cada uno de los observables, que representan 
   * cada servicio, secuencialmente sin que se ejecuten en desorden.
   * 
   * Se utilizan promesas para ejecutar las funciones async de sdk de aws s3.
   * 
   * FIXME: A la fecha (2018/12/17) hasta la version 2.377.0(2.4.8) el sdk de aws para javascript tiene un bug para
   * cuando se requiere borrar objetos en el bucket. El codigo del bug es: SignatureDoesNotMatch
	 *
	 * @author Andrés Felipe Vargas López
	 * @version Dec 15, 2018
	 * @since 6.2.4
   * @param usuModificador - Usuario que utiliza el metodo
   * @param banner - POJO que sera enviado al servicio, para ser inactivado.
	 * @throws Error
	 * @returns Observable<any>
	 */
  public disableBanner(usuModificador: string, banner: Banner, secretId: string, secretKey: string ): Observable<any> {

    var adjunto = new Adjunto(banner.adjuId_SicaAdjunto, null, null,
      null, null, null, null, null, usuModificador, null, null, null);

    const thread = this.adjuntoService.inactiveSicaAdjuntoAmazonS3(adjunto).pipe(
      concatMap((respuestaGenerica: GenericResponse) => {
        if (respuestaGenerica.codigo === GLOBAL.HTTP_OK) {

          const bucket = new S3(
            {
              accessKeyId: secretId,
              secretAccessKey: secretKey,
              region: GLOBAL.REGION_S3
            }
          );

          const params = {
            Bucket: GLOBAL.NOMBRE_BUCKET,
            Delete: {
              Objects: [
                { Key: respuestaGenerica.lista[0].rutaAdjunto }
              ]
            }
          };

          let response = [respuestaGenerica.lista[0], bucket.deleteObjects(params, function (err, data) {
            if(err !== null && err !== undefined && 
              !((err.stack as string).toLowerCase().includes(GLOBAL.BUG_ERROR_S3.toLowerCase()))){
              throw ("No fué posible subir el archivo: " + err);
            }
          }).promise()];

          return of(response);

        } else {
          throw (respuestaGenerica.mensaje);
        }
      }),
      concatMap((response: any) => {
        if (response == null || response == undefined) {
          throw ("No fué posible cargar el archivo");
        }
        if (response[0] == null || response[0] == undefined) {
          throw ("No fué posible cargar el archivo");
        }
        banner.adjuId_SicaAdjunto = response[0].adjuId;
        return of(response[1], this.bannerService.actualizar(banner).toPromise());
      }),
      concatMap((response: Promise<any>) => {
        return new Promise((resolve, reject) => {
          response.then(
            function (result) {
              if (result !== null && result !== undefined && result.codigo !== undefined && result.codigo !== null) {
                let response: GenericResponse = result;
                if (response.codigo !== GLOBAL.HTTP_OK) {
                  throw (result.mensaje);
                }
              }
              resolve(result);
            }, function (err) {
              if(err !== null && err !== undefined && 
                !((err.stack as string).toLowerCase().includes(GLOBAL.BUG_ERROR_S3.toLowerCase()))){
                  reject(err);
              }else{
                resolve(err);
              }
            });

        }).then(function (result) {
          return result;
        }, function (err) {
          throw (err);
        });

      })
    );

    return thread;

  }

}
